<template>
  <div class="gx-detail">
    <gx-loading :show="pageLoading" text="加载中..." />

    <div class="gx-detail__head">
      <button class="gx-detail__back" @click="goBack">〈 返回列表</button>
      <span class="gx-detail__head-title">微店售后详情</span>
    </div>

    <div v-if="loadError" class="gx-detail__error">
      <p>{{ loadError }}</p>
      <button class="gx-detail__btn gx-detail__btn--primary" @click="goBack">返回列表</button>
    </div>

    <div v-else-if="aftersale" class="gx-detail__layout">
      <div class="gx-detail__main">
        <div class="gx-detail__card">
          <div class="gx-detail__card-title">
            <span class="gx-detail__card-title-bar"></span>
            售后信息
            <span v-if="typeTagText" class="gx-detail__tag gx-detail__tag--type">{{ typeTagText }}</span>
          </div>
          <div class="gx-detail__grid">
            <div class="gx-detail__row">
              <span class="gx-detail__label">售后状态</span>
              <span class="gx-detail__val">{{ statusText }}</span>
            </div>
            <div class="gx-detail__row">
              <span class="gx-detail__label">微店订单号</span>
              <span class="gx-detail__val">
                {{ aftersale.wx_order_id || '—' }}
                <i v-if="aftersale.wx_order_id" class="gx-detail__copy" @click="copyText(aftersale.wx_order_id)">⧉</i>
              </span>
            </div>
            <div class="gx-detail__row">
              <span class="gx-detail__label">售后编号</span>
              <span class="gx-detail__val">
                {{ aftersale.wx_after_sale_id || '—' }}
                <i v-if="aftersale.wx_after_sale_id" class="gx-detail__copy" @click="copyText(aftersale.wx_after_sale_id)">⧉</i>
              </span>
            </div>
            <div class="gx-detail__row">
              <span class="gx-detail__label">申请时间</span>
              <span class="gx-detail__val">{{ applyTimeText }}</span>
            </div>
            <div class="gx-detail__row">
              <span class="gx-detail__label">退款金额</span>
              <span class="gx-detail__val gx-detail__val--money">{{ refundAmountText }}</span>
            </div>
            <div class="gx-detail__row">
              <span class="gx-detail__label">申请原因</span>
              <span class="gx-detail__val">{{ reasonText }}</span>
            </div>
            <div class="gx-detail__row">
              <span class="gx-detail__label">店铺</span>
              <span class="gx-detail__val">{{ shopName }}</span>
            </div>
          </div>
          <div v-if="canAccept || canReject" class="gx-detail__actions" style="margin-top: 16px;">
            <button v-if="canAccept" class="gx-detail__btn gx-detail__btn--sm gx-detail__btn--primary" :disabled="operateSubmitting" @click="bindAccept">
              {{ operateSubmitting ? '处理中...' : '同意售后' }}
            </button>
            <button v-if="canReject" class="gx-detail__btn gx-detail__btn--sm" :disabled="operateSubmitting" @click="bindReject">拒绝</button>
          </div>
        </div>

        <div class="gx-detail__card">
          <div class="gx-detail__card-title">
            <span class="gx-detail__card-title-bar"></span>
            商品信息
          </div>
          <div v-if="productRow" class="gx-detail__product">
            <img v-if="productPic" class="gx-detail__product-img" :src="productPic" alt="" />
            <div class="gx-detail__product-body">
              <p class="gx-detail__product-title">{{ productRow.product_name || productRow.title || '—' }}</p>
              <p class="gx-detail__product-spec">{{ productRow.spec_value || productRow.sku_name || '—' }}</p>
              <p class="gx-detail__product-meta">商品ID：{{ productRow.product_id || productRow.goods_id || '—' }}</p>
            </div>
          </div>
          <p v-else class="gx-detail__ops-empty-tip">暂无商品信息</p>
        </div>

        <div v-if="alibabaAftersale" class="gx-detail__card">
          <div class="gx-detail__card-title">
            <span class="gx-detail__card-title-bar"></span>
            1688 售后
          </div>
          <div class="gx-detail__grid">
            <div class="gx-detail__row">
              <span class="gx-detail__label">退款状态</span>
              <span class="gx-detail__val">{{ alibabaStatusText }}</span>
            </div>
            <div class="gx-detail__row">
              <span class="gx-detail__label">1688 售后单号</span>
              <span class="gx-detail__val">
                <template v-if="alibabaAftersale.refund_id">
                  <a
                    class="gx-detail__link"
                    target="_blank"
                    :href="'https://dispute.1688.com/refund/assureRefundDetail.htm?refundId=' + alibabaAftersale.refund_id"
                  >{{ alibabaAftersale.refund_id }}</a>
                </template>
                <template v-else>—</template>
              </span>
            </div>
            <div class="gx-detail__row">
              <span class="gx-detail__label">采购单号</span>
              <span class="gx-detail__val">{{ alibabaAftersale.alibaba_order_id || '—' }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GxLoading from '../../components/newUi/GxLoading.vue'
import { getAftersaleDetail, postAftersaleAccept, postAftersaleReject } from '../../api/wxshop/aftersale'

export default {
  name: 'WxAfterSalesDetailPage',
  components: { GxLoading },
  props: {
    aftersaleId: { type: [Number, String], default: '' }
  },
  data() {
    return {
      pageLoading: false,
      loadError: '',
      aftersale: null,
      operateSubmitting: false
    }
  },
  computed: {
    afterId() {
      if (this.aftersaleId !== '' && this.aftersaleId != null) {
        const id = parseInt(this.aftersaleId, 10)
        return Number.isFinite(id) ? id : 0
      }
      const q = this.$route.query.id
      const id = parseInt(q, 10)
      return Number.isFinite(id) ? id : 0
    },
    textPart() {
      const tp = this.aftersale && this.aftersale.text_part
      return tp && typeof tp === 'object' && !Array.isArray(tp) ? tp : {}
    },
    typeTagText() {
      return this.textPart.aftersale_type_text || this.aftersale?.aftersale_type_text || ''
    },
    statusText() {
      return this.textPart.aftersale_status_text || this.aftersale?.aftersale_status_text || '—'
    },
    reasonText() {
      return this.textPart.reason_text || this.aftersale?.reason_text || '—'
    },
    applyTimeText() {
      return this.aftersale?.apply_time || this.aftersale?.wx_apply_time || this.aftersale?.created_at || '—'
    },
    refundAmountText() {
      const v = this.aftersale?.refund_amount
      if (v == null || v === '') return '—'
      const n = Number(v)
      if (!Number.isFinite(n)) return '¥' + v
      return '¥' + (n / 100).toFixed(2)
    },
    shopName() {
      const s = this.aftersale?.shop
      return (s && s.shop_name) || this.aftersale?.shop_name || '—'
    },
    productRow() {
      return (this.aftersale && (this.aftersale.order_product || this.aftersale.product)) || null
    },
    productPic() {
      if (!this.productRow) return ''
      return this.productRow.product_pic || this.productRow.thumb_img || this.productRow.img || ''
    },
    alibabaAftersale() {
      return this.aftersale?.alibaba_aftersale || null
    },
    alibabaStatusText() {
      if (!this.alibabaAftersale) return '—'
      return this.alibabaAftersale.refund_status_text || this.alibabaAftersale.status_text || this.alibabaAftersale.refund_status || '—'
    },
    canAccept() {
      return !!(this.aftersale && this.aftersale.can_accept)
    },
    canReject() {
      return !!(this.aftersale && this.aftersale.can_reject)
    }
  },
  watch: {
    '$route.query.id'() {
      this.loadDetail()
    }
  },
  created() {
    this.loadDetail()
  },
  methods: {
    loadDetail() {
      if (!this.afterId) {
        this.loadError = '缺少售后单 ID'
        return
      }
      this.pageLoading = true
      this.loadError = ''
      getAftersaleDetail({ id: this.afterId })
        .then((res) => {
          this.pageLoading = false
          if (res.code !== 200) {
            this.loadError = res.message || res.msg || '加载失败'
            this.aftersale = null
            return
          }
          this.aftersale = res.data || null
          if (!this.aftersale) this.loadError = '未找到售后记录'
        })
        .catch(() => {
          this.pageLoading = false
          this.loadError = '售后详情接口未就绪，请确认后端服务与数据表已部署'
          this.aftersale = null
        })
    },
    goBack() {
      this.$router.replace({ path: '/new_aftersales_workbench', query: { menu: 'wx-after-mag' } }).catch(() => {})
    },
    copyText(text) {
      const input = document.createElement('input')
      input.value = text
      document.body.appendChild(input)
      input.select()
      document.execCommand('Copy')
      document.body.removeChild(input)
      this.$message({ message: '复制成功', type: 'success' })
    },
    bindAccept() {
      if (!this.aftersale?.id || this.operateSubmitting) return
      this.$confirm('确认同意该售后申请？', '提示', { type: 'warning' })
        .then(() => {
          this.operateSubmitting = true
          postAftersaleAccept({ id: this.aftersale.id })
            .then((res) => {
              this.operateSubmitting = false
              if (res.code !== 200) {
                this.$message.error(res.message || res.msg || '操作失败')
                return
              }
              this.$message.success('操作成功')
              this.loadDetail()
            })
            .catch(() => {
              this.operateSubmitting = false
              this.$message.error('操作失败')
            })
        })
        .catch(() => {})
    },
    bindReject() {
      if (!this.aftersale?.id || this.operateSubmitting) return
      this.$prompt('请输入拒绝原因', '拒绝售后', {
        inputPattern: /\S+/,
        inputErrorMessage: '请填写拒绝原因'
      })
        .then(({ value }) => {
          this.operateSubmitting = true
          postAftersaleReject({ id: this.aftersale.id, reason: value })
            .then((res) => {
              this.operateSubmitting = false
              if (res.code !== 200) {
                this.$message.error(res.message || res.msg || '操作失败')
                return
              }
              this.$message.success('已拒绝')
              this.loadDetail()
            })
            .catch(() => {
              this.operateSubmitting = false
              this.$message.error('操作失败')
            })
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../styles/gx-after-sales-detail.scss';

.gx-detail__product {
  display: flex;
  gap: 12px;
  padding: 4px 0;
}
.gx-detail__product-img {
  width: 72px;
  height: 72px;
  border-radius: 6px;
  object-fit: cover;
  border: 1px solid #e1e5ee;
  flex-shrink: 0;
}
.gx-detail__product-body {
  min-width: 0;
}
.gx-detail__product-title {
  margin: 0 0 6px;
  font-size: 14px;
  font-weight: 600;
  color: #1a1a2e;
}
.gx-detail__product-spec,
.gx-detail__product-meta {
  margin: 0 0 4px;
  font-size: 12px;
  color: #6a6a8a;
}
.gx-detail__val--money {
  color: #c8443c;
  font-weight: 700;
}
</style>
